import {loadStripe} from "@stripe/stripe-js";
import {CONFIGURATION} from "../utils/constants";

export const stripePromise = loadStripe(CONFIGURATION.stripe.publishableKey);